import { useEffect, useState, useRef } from "react";
import { fetchDonations } from "../api/donationsApi";

const LiveDonationPopup = () => {
    const [donations, setDonations] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visible, setVisible] = useState(false);

    const timeoutRef = useRef(null);

    useEffect(() => {
    fetchDonations().then(res => setDonations(res.data))
      .catch(err => console.error("Error fetching donations", err));
  }, []);

    // Popup cycle with RANDOM timing
    useEffect(() => {
  if (!donations.length) return;

  const cyclePopup = () => {
    setVisible(true);

    // Stay visible for 3–4s
    const visibleDuration = 3000 + Math.random() * 1000;

    timeoutRef.current = setTimeout(() => {
      setVisible(false);

      // Pick a random donor index
      const randomIndex = Math.floor(Math.random() * donations.length);
      setCurrentIndex(randomIndex);

      // Wait random 6–8s before next popup
      const nextDelay = 6000 + Math.random() * 2000;
      timeoutRef.current = setTimeout(cyclePopup, nextDelay);
    }, visibleDuration);
  };

  cyclePopup();

  return () => clearTimeout(timeoutRef.current);
}, [donations]);

    if (!donations.length) return null;

    const donor = donations[currentIndex];
    const initial = donor.name?.charAt(0)?.toUpperCase() || "🙏";

    return (
        <div
            className={`
    fixed bottom-24 right-4 md:bottom-6 md:left-6 md:right-auto z-50
    pointer-events-none
    transition-all duration-500 ease-out
    ${visible
                    ? "opacity-100 translate-x-0 translate-y-0"
                    : "opacity-0 translate-x-16 md:translate-x-0 translate-y-6"
                }
  `}
        >

            <div className="pointer-events-auto bg-white/95 backdrop-blur-xl shadow-xl border border-rose-200 rounded-2xl px-5 py-3 flex items-center gap-4">


                {/* Avatar Initial */}
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose-100 to-yellow-100 text-[#9A134C] flex items-center justify-center font-semibold text-lg shadow-inner">
                    {initial}
                </div>

                {/* Text */}
                <div>
                    <p className="text-sm text-gray-600">
                        <span className="font-semibold text-[#9A134C]">
                            {donor.name}
                        </span>{" "}
                        donated
                    </p>
                    <p className="text-lg font-bold text-[#E7C873]">
                        ₹{donor.amount}
                    </p>
                    <p className="text-xs text-gray-400">recently</p>
                </div>
            </div>
        </div>
    );
};

export default LiveDonationPopup;

